import apiClient from './client';
import {
  CheckNumberProposal,
  AcceptProposalRequest,
  ExtractCheckNumbersResponse,
  BulkProposalActionRequest,
  BulkProposalActionResponse,
} from '../types';

export const checkNumberProposalsApi = {
  /**
   * Run check number extraction on ledger entries
   */
  extractCheckNumbers: async (clientId: string): Promise<ExtractCheckNumbersResponse> => {
    const response = await apiClient.post<ExtractCheckNumbersResponse>(
      `/clients/${clientId}/check-number-proposals/extract`
    );
    return response.data;
  },

  /**
   * Get all proposals for a client, optionally filtered by status
   */
  getProposals: async (
    clientId: string,
    status?: 'pending' | 'accepted' | 'rejected'
  ): Promise<CheckNumberProposal[]> => {
    const params: Record<string, string> = {};
    if (status) {
      params.status = status;
    }
    const response = await apiClient.get<CheckNumberProposal[]>(
      `/clients/${clientId}/check-number-proposals`,
      { params }
    );
    return response.data;
  },

  /**
   * Accept a proposal, optionally with an edited check number
   */
  acceptProposal: async (
    clientId: string,
    proposalId: string,
    request?: AcceptProposalRequest
  ): Promise<CheckNumberProposal> => {
    const response = await apiClient.post<CheckNumberProposal>(
      `/clients/${clientId}/check-number-proposals/${proposalId}/accept`,
      request || {}
    );
    return response.data;
  },

  /**
   * Reject a proposal
   */
  rejectProposal: async (
    clientId: string,
    proposalId: string
  ): Promise<CheckNumberProposal> => {
    const response = await apiClient.post<CheckNumberProposal>(
      `/clients/${clientId}/check-number-proposals/${proposalId}/reject`
    );
    return response.data;
  },

  /**
   * Bulk accept multiple proposals
   */
  bulkAccept: async (
    clientId: string,
    proposalIds: string[]
  ): Promise<BulkProposalActionResponse> => {
    const request: BulkProposalActionRequest = { proposal_ids: proposalIds };
    const response = await apiClient.post<BulkProposalActionResponse>(
      `/clients/${clientId}/check-number-proposals/bulk-accept`,
      request
    );
    return response.data;
  },

  /**
   * Bulk reject multiple proposals
   */
  bulkReject: async (
    clientId: string,
    proposalIds: string[]
  ): Promise<BulkProposalActionResponse> => {
    const request: BulkProposalActionRequest = { proposal_ids: proposalIds };
    const response = await apiClient.post<BulkProposalActionResponse>(
      `/clients/${clientId}/check-number-proposals/bulk-reject`,
      request
    );
    return response.data;
  },
};
